export const INIT_LOADING_DRAWER = "INIT_LOADING_DRAWER"
export const END_LOADING_DRAWER = "END_LOADING_DRAWER"
export const SET_DRAWER_OPEN = "SET_DRAWER_OPEN"
export const ERROR = "ERROR"